export const Pages = {
  HOME: {
    path: '/',
    link: '/',
    label: 'Home',
  },
  POSITIONS: {
    path: 'positions',
    link: '/positions',
    label: 'Positions',
  },
  TASKS: {
    path: 'tasks',
    link: '/tasks',
    label: 'Tasks',
  },
  BENCHMARKS: {
    path: 'benchmarks',
    link: '/benchmarks',
    label: 'Benchmarks',
  },
  JOB_DESCRIPTIONS: {
    path: 'job-descriptions',
    link: '/job-descriptions',
    label: 'Job Descriptions',
  },
  CONFIGURATION: {
    path: 'configuration',
    link: '/configuration',
    label: 'Configuration',
    children: {
      LANDING: {
        path: '',
        link: '/configuration',
        label: 'Documentation',
      },
      API_CONFIGURATION: {
        path: 'api-configuration',
        link: '/configuration/api-configuration',
        label: 'API Configuration',
        children: {
          AI_CONFIGURATION: {
            path: 'ai',
            link: '/configuration/api-configuration/ai',
            label: 'AI Configuration',
          },
          SF_CONFIGURATION: {
            path: 'sf',
            link: '/configuration/api-configuration/sf',
            label: 'SF Configuration',
          },
        },
      },
      AI_PROMPTS: {
        path: 'ai-prompts',
        link: '/configuration/ai-prompts',
        label: 'AI Prompts',
        children: {
          PROMPT_PLAYGROUND: {
            path: 'playground',
            link: '/configuration/ai-prompts/playground',
            label: 'Prompt Playground',
          },
        },
      },
      FIELD_MAPPINGS: {
        path: 'field-mappings',
        link: '/configuration/field-mappings',
        label: 'Field Mappings',
      },
      COUNTRY_CODES: {
        path: 'country-codes',
        link: '/configuration/country-codes',
        label: 'Country Codes',
      },
      JOB_CLASSIFICATION: {
        path: 'job-classification',
        link: '/configuration/job-classification',
        label: 'JobClassification',
        children: {
          STRUCTURE: {
            path: '',
            link: '/configuration/job-classification',
            label: 'Structure',
          },
          JOB_LEVELS: {
            path: 'job-levels',
            link: '/configuration/job-classification/job-levels',
            label: 'Job Levels',
          },
          JOB_CLASSIFICATION_CODES: {
            path: 'job-classification-codes',
            link: '/configuration/job-classification/job-classification-codes',
            label: 'Job Classification Codes',
          },
          JOB_FAMILIES: {
            path: 'job-families',
            link: '/configuration/job-classification/job-families',
            label: 'Job Families',
          },
          SKILL_TYPES: {
            path: 'skill-types',
            link: '/configuration/job-classification/skill-types',
            label: 'Skill Types',
          },
          SKILL_CLUSTERS: {
            path: 'skill-clusters',
            link: '/configuration/job-classification/skill-clusters',
            label: 'Skill Clusters',
          },
          SKILL_LEVELS: {
            path: 'skill-levels',
            link: '/configuration/job-classification/skill-levels',
            label: 'Skill Levels',
          },
          SKILLS: {
            path: 'skills',
            link: '/configuration/job-classification/skills',
            label: 'Skills',
          },
          COMPETENCIES: {
            path: 'competencies',
            link: '/configuration/job-classification/competencies',
            label: 'Competencies',
          },
          MAPPINGS: {
            path: 'mappings',
            link: '/configuration/job-classification/mappings',
            label: 'Mappings',
            children: {
              JOB_FAMILY_COMPETENCY: {
                path: 'job-family-competency',
                link: '/configuration/job-classification/mappings/job-family-competency',
                label: 'Job Family ↔ Competency',
              },
              JOB_CLASSIFICATION_SKILL: {
                path: 'job-classification-skill',
                link: '/configuration/job-classification/mappings/job-classification-skill',
                label: 'Classification ↔ Skill',
              },
            },
          },
        },
      },
    },
  },
} as const;
